import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BUSINESS } from '@/lib/constants';

export default function StickyMobileCtaBar() {
  return (
    <div
      className="sm:hidden fixed inset-x-0 bottom-0 z-50 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/90 shadow-[var(--shadow-soft)]"
      data-testid="mobile-sticky-cta-bar"
    >
      <div className="grid grid-cols-3">
        <a
          href={BUSINESS.phoneTel}
          className="flex flex-col items-center justify-center gap-0.5 py-3 bg-primary text-primary-foreground active:scale-[0.98] transition-transform duration-150"
          aria-label={`Call ${BUSINESS.phone}`}
          data-testid="mobile-cta-call"
        >
          <Phone className="h-5 w-5" />
          <span className="text-xs font-medium">Call</span>
        </a>
        <a
          href={BUSINESS.whatsappUrl}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 py-3 bg-secondary text-secondary-foreground active:scale-[0.98] transition-transform duration-150"
          aria-label="WhatsApp"
          data-testid="mobile-cta-whatsapp"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-xs font-medium">WhatsApp</span>
        </a>
        <Link
          to="/request-a-ride"
          className="flex flex-col items-center justify-center gap-0.5 py-3 bg-accent text-accent-foreground active:scale-[0.98] transition-transform duration-150"
          aria-label="Request a ride"
          data-testid="mobile-cta-request"
        >
          <Calendar className="h-5 w-5" />
          <span className="text-xs font-medium">Request</span>
        </Link>
      </div>
    </div>
  );
}
